import * as React from 'react';
import {LoginStore} from '../../../context/vwid/LoginStore';

export function createBtnSettingsClick(
    loginStore: LoginStore
): ((e: React.MouseEvent) => void) | undefined {
    if (loginStore.customerType === 'private' && loginStore.hasProfileUrl()) {
        return (e: React.MouseEvent) => {
            e.preventDefault();
            loginStore.openProfileTab();
        };
    }

    if (
        loginStore.customerType === 'commercial' &&
        loginStore.hasCommercialProfileUrl()
    ) {
        return (e: React.MouseEvent) => {
            e.preventDefault();
            loginStore.openCommercialProfileTab();
        };
    }

    return undefined;
}
